export default __webpack_public_path__ + "static/media/end.8051e267.flac";